import { createContext } from 'react';

const refreshFunctionContext = createContext();
export default refreshFunctionContext;
